import type { ColumnDef, HeatmapMapping } from '@deckspace/types';
import {
  rowsToColumnar,
  getColumn,
  defsByName,
  sortIndicesByType,
  permute,
} from '../shared/pivot.js';

export interface HeatmapResult {
  xLabels: string[];
  yLabels: string[];
  matrix: number[][];
}

export function prepHeatmapSeries(
  rows: Record<string, unknown>[],
  columnDefs: ColumnDef[],
  mapping: HeatmapMapping
): HeatmapResult {
  const tableData = rowsToColumnar(rows);
  const defs = defsByName(columnDefs);

  const rawX = [...new Set(getColumn<string>(tableData, mapping.xLabels).map(String))];
  const rawY = [...new Set(getColumn<string>(tableData, mapping.yLabels).map(String))];

  const xLabels = permute(rawX, sortIndicesByType(rawX, defs[mapping.xLabels]?.type));
  const yLabels = permute(rawY, sortIndicesByType(rawY, defs[mapping.yLabels]?.type));

  const matrix: number[][] = yLabels.map(() => xLabels.map(() => 0));
  const xRaw = getColumn<unknown>(tableData, mapping.xLabels);
  const yRaw = getColumn<unknown>(tableData, mapping.yLabels);
  const vRaw = getColumn<unknown>(tableData, mapping.value);
  for (let i = 0; i < xRaw.length; i++) {
    const xi = xLabels.indexOf(String(xRaw[i]));
    const yi = yLabels.indexOf(String(yRaw[i]));
    if (xi >= 0 && yi >= 0) {
      const matrixRow = matrix[yi];
      if (matrixRow) matrixRow[xi] = Number(vRaw[i]) || 0;
    }
  }
  return { xLabels, yLabels, matrix };
}
